import React from 'react'
import xhr from 'xhr'

// Tipos de programa activos (api::program-type). Se piden una sola vez por
// sesión de la página y se comparten entre pantallas.
let cache = null

const loadProgramTypes = () => {
  if (!cache) {
    cache = xhr(
      '/program-types?filters[active][$eq]=true&fields[0]=name&fields[1]=slug&fields[2]=order&pagination[pageSize]=100'
    )
      .then((res) =>
        res.data.data
          .filter((el) => el.slug)
          .sort((a, b) => (a.order ?? 999) - (b.order ?? 999) || a.name.localeCompare(b.name, 'es'))
      )
      .catch((error) => {
        cache = null
        throw error
      })
  }
  return cache
}

export default function useProgramTypes() {
  const [programTypes, setProgramTypes] = React.useState([])

  React.useEffect(() => {
    let mounted = true
    loadProgramTypes()
      .then((list) => mounted && setProgramTypes(list))
      .catch((error) => console.error(error))
    return () => {
      mounted = false
    }
  }, [])

  return programTypes
}
